import { CoreMenuCollectionPage } from 'dispensary/core-menu/collection';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

export default Object.assign(CoreMenuCollectionPage, { layout: CoreMenuLayout });
